/* Cable-cut badge renderer - parses product title for cable size + cut length. */
(function () {
  function parseSize(title) {
    // First "Nmm" or "N.Nmm" token in the title -> cable size.
    var m = title.match(/(\d+(?:\.\d+)?)\s*mm\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (n <= 0 || n > 500) return null;
    return n + 'mm';
  }

  function parseLength(title) {
    // "Nm Cut|Drum|Roll" -> length in metres.
    // Covers pre-cut pieces (10m Cut), full drums (100m / 500m Drum),
    // and rolled cables (100m Roll).
    var m = title.match(/(\d+(?:\.\d+)?)\s*m\s+(?:Cut|Drum|Roll)\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (n <= 0 || n > 1000) return null;
    return n + 'm';
  }

  function tagOverrideSize(tags) {
    // "cable-size-2.5" or "cable-size-2.5mm" -> force the size badge.
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].match(/^cable-size-(\d+(?:\.\d+)?)(?:mm)?$/i);
      if (m) return parseFloat(m[1]) + 'mm';
    }
    return null;
  }

  function tagOverrideLength(tags) {
    // "cable-length-25" or "cable-length-25m" -> force the length badge.
    for (var i = 0; i < tags.length; i++) {
      var m = tags[i].match(/^cable-length-(\d+(?:\.\d+)?)m?$/i);
      if (m) return parseFloat(m[1]) + 'm';
    }
    return null;
  }

  function process(el) {
    if (el.classList.contains('--cable-processed')) return;
    el.classList.add('--cable-processed');

    var title = el.dataset.title || '';
    var tags = (el.dataset.tags || '').split('|').filter(Boolean);

    var hideSize = tags.indexOf('no-size-badge') !== -1;
    var hideLen  = tags.indexOf('no-length-badge') !== -1;

    // Force-value tags win over auto-parse; auto-parse runs only if no override.
    var size = hideSize ? null : (tagOverrideSize(tags)   || parseSize(title));
    var len  = hideLen  ? null : (tagOverrideLength(tags) || parseLength(title));

    if (!size && !len) {
      el.style.display = 'none';
      return;
    }

    // Stacked layout: size (small, with mm² superscript) on top, length (bigger) below.
    // size string looks like "2.5mm" - swap the "mm" for "mm<sup>2</sup>".
    var rows = '';
    if (size) {
      var sizeHtml = size.replace(/mm$/, 'mm<sup>2</sup>');
      rows += '<span class="cable-cut-badge__size">' + sizeHtml + '</span>';
    }
    if (len) {
      rows += '<span class="cable-cut-badge__len">' + len + '</span>';
    }
    el.innerHTML = '<span class="cable-cut-badge">' + rows + '</span>';
  }

  function run() {
    document.querySelectorAll('.cable-cut-badges').forEach(process);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('halo:collection:loaded', run);
  document.addEventListener('halo:product-grid:updated', run);

  if (window.MutationObserver) {
    var debounce = null;
    var mo = new MutationObserver(function () {
      if (debounce) return;
      debounce = setTimeout(function () {
        debounce = null;
        run();
      }, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
